import { render } from "./SubDomains.vue?vue&type=template&id=1ff8d7af&scoped=true"
import script from "./SubDomains.vue?vue&type=script&lang=js"
export * from "./SubDomains.vue?vue&type=script&lang=js"

import "./SubDomains.vue?vue&type=style&index=0&id=1ff8d7af&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8d7af"]])

export default __exports__